//*Libraries imports

//*Types
export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

/**
 * Busca o endereço através do CEP utilizando a API ViaCEP
 * @param cep O CEP a ser consultado (apenas números ou formatado)
 * @returns Promessa com os dados do endereço ou nulo em caso de erro
 */
export async function getAddressByCep(cep: string): Promise<ViaCepResponse | null> {
  const cleanedCep = cep.replace(/\D/g, "");

  if (cleanedCep.length !== 8) {
    return null;
  }

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanedCep}/json/`);
    const data: ViaCepResponse = await response.json();

    if (data.erro) {
      return null;
    }

    return data;
  } catch (error) {
    console.error("Erro ao buscar CEP:", error);
    return null;
  }
}
